import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import values from 'ramda/src/values';
import ErrorBoundary from '@components/@core/ErrorBoundary';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import AppActions from '~/actions/app';
import CommunityActions from '~/actions/community';
import CompanyActions from '~/actions/company';
import VendorActions from '~/actions/vendor';
import { BLOG_COMPANY_TABS } from '~/services/constants';
import CategoryMGT from './CategoryMGT';
import Drafts from './Drafts';
import Published from './Published';

const BlogAdmin = ({ companyId, userId, data, onBlogDetail }) => {
    const [active, setActive] = useState('drafts');
    const [search, setSearch] = useState(false);

    const blog = data?.vrs?.blog?.data;
    const departments = useSelector((state) => state.company.blogCategories);
    const authors = blog?.admins || [];
    const categories = blog?.blog_categories ? values(blog.blog_categories) : [];

    const dispatch = useDispatch();
    const handleDeletePost = (post) => {
        const payload = {
            data: { post: { id: post.id, blog_id: post.data?.blog_id, user_id: post.user_id } },
            callback: handleChangePostPage,
        };
        dispatch(VendorActions.deleteblogpostRequest(payload));
    };

    const handlePostEvent = (e, post) => {
        if (e === 'delete') {
            const payload = {
                type: 'Confirm',
                data: { before: { title: 'Delete', body: 'Are you sure you want to delete this post?' } },
                callBack: { onYes: () => handleDeletePost(post) },
            };
            dispatch(AppActions.modalRequest(payload));
        } else {
            const payload = {
                type: 'Edit Blog Post',
                data: { before: { post, businessId: data.id, blogId: data?.vrs?.blog?.id, blog } },
            };
            dispatch(AppActions.modalRequest(payload));
        }
    };

    const handleChangePostPage = (page) => {
        dispatch(CompanyActions.getbusinessblogRequest({ businessId: data.id, payload: { page } }, false));
    };

    const handleSearchPosts = (e) => {
        setSearch(!!e);
        const payload = {
            writer_id: [e?.author],
            category_id: e?.categoryId,
            blog_categories: e?.blogCategory,
            search: e?.search,
        };
        dispatch(CompanyActions.getbusinessblogRequest({ businessId: data.id, payload }, false));
    };

    const handleTab = (e) => {
        const name = e?.name;
        if (name !== 'category mgt') dispatch(CompanyActions.getbusinessblogRequest({ businessId: data.id }, false));
        setSearch(false);
        setActive(name);
    };

    const handleDetail = (e) => () => {
        const payload = {
            data: {
                community_user_id: userId,
                events: [{ content_id: e.id, source: 'vr-component', type: 'click' }],
            },
        };
        dispatch(CommunityActions.addcontenteventRequest(payload));
        onBlogDetail(e);
        window.location = e?.data?.permalink;
    };

    return (
        <ErrorBoundary className="company-profile-blog-admin card">
            <p className="dsl-b22 bold my-2">Blog Admin</p>
            <ResponsiveTabs active={active} data={BLOG_COMPANY_TABS} getId={(e) => e['name']} getValue={(e) => e['label']} onTab={handleTab} />
            <Tab eventKey="drafts" active={active}>
                <Drafts
                    data={blog?.drafts}
                    authors={authors}
                    categories={categories}
                    departments={departments}
                    search={search && active === 'drafts'}
                    onSearch={handleSearchPosts}
                    onSelect={handlePostEvent}
                />
            </Tab>
            <Tab eventKey="published" active={active}>
                <Published
                    data={blog?.posts}
                    authors={authors}
                    categories={categories}
                    departments={departments}
                    search={search && active === 'published'}
                    onSearch={handleSearchPosts}
                    onSelect={handlePostEvent}
                    onChangePage={handleChangePostPage}
                    onDetail={(e) => handleDetail(e)}
                />
            </Tab>
            <Tab eventKey="category" active={active}>
                <CategoryMGT blog={blog} userId={data?.user_id} companyId={data?.id} />
            </Tab>
        </ErrorBoundary>
    );
};

BlogAdmin.propTypes = {
    companyId: PropTypes.number,
    userId: PropTypes.number,
    data: PropTypes.shape({
        blog: PropTypes.shape({
            entity: PropTypes.any,
            blogs: PropTypes.array,
            posts: PropTypes.array,
            title: PropTypes.string,
            blog: PropTypes.any,
            drafts: PropTypes.array,
            has_blog: PropTypes.bool,
            can_edit_blog: PropTypes.bool,
        }),
    }),
};

BlogAdmin.defaultProps = {
    companyId: null,
    userId: null,
    data: {
        blog: {
            entity: {},
            blogs: [],
            posts: [],
            title: '',
            blog: {},
            drafts: [],
            has_blog: true,
            can_edit_blog: false,
        },
    },
};

export default BlogAdmin;
